import React, { useState, useEffect } from "react";
import { Grid, Box, MenuItem } from "@material-ui/core";

import C1InputField from "app/c1component/C1InputField";
import C1SelectField from "app/c1component/C1SelectField";
import C1HeaderTitle from "app/c1component/C1HeaderTitle";
import cacheDataService from "app/services/cacheDataService";
import { makeStyles } from "@material-ui/core/styles";
import Accordion from "@material-ui/core/Accordion";
import AccordionSummary from "@material-ui/core/AccordionSummary";
import AccordionDetails from "@material-ui/core/AccordionDetails";
import Typography from "@material-ui/core/Typography";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import RaeoHistory from "./RaeoHistory";

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
  },
  heading: {
    fontSize: theme.typography.pxToRem(15),
    fontWeight: theme.typography.fontWeightRegular,
    backgroundColor: "#3c77d0",
  },
}));


const RaeoAppAssessmentValidation = ({
  inputData,
  auditList,
  props,
  handleInputChange,
  handleInputChangeDeep,
  //handleInputChangeCommon,
  onRatingValidation,
  viewType,  
  isDisabled,
  errors,
  isSubmitting,
}) => {
  const [expandedList, setExpandedList] = useState([]);
  const [refreshPage, setRefreshPage] = useState(0);
  const [groupAssessArray, setGroupAssessArray] = useState([]);

  const classes = useStyles();

  const handleInputChangeDeepWrap = (e) => {
    const name = e.target.name;
    const value = e.target.value;
    console.log("name", name, value);
    handleInputChangeDeep(name, value);
    setRefreshPage(refreshPage + 1);
  }

  //console.log("assessArray", assessArray);
  const groupByAssess = () => {
    
    let assessArray = inputData.TSctRaeoAppAssessments || [];

    assessArray.sort(
      (a1, a2) =>
        a1?.TSctRaeoMstAssessment?.asmSeq - a2?.TSctRaeoMstAssessment?.asmSeq
    );

    let groupAssessArray = assessArray.reduce((accumulator, item) => {
      //accumulator + currentValue.jtJobDn
      let asmSeq = item.TSctRaeoMstAssessment?.asmSeq;
      let groupId = Math.floor(asmSeq);
      let idx = accumulator.findIndex(
        (assess) => groupId === assess?.header?.TSctRaeoMstAssessment?.asmSeq
      );
      //console.log("---", asmSeq, groupId, idx, accumulator);

      if (asmSeq === groupId) {
        // header
        if (idx < 0) {
          accumulator.push({ header: item, body: [] });
          expandedList.push(true);
        }
      } else {
        // body
        if (idx >= 0) {
          accumulator[idx].body.push(item);
        }
      }
      return accumulator;
    }, []);
    /*
    groupAssessArray.map( (item, idx) => {
        item.body.sort( (a1, a2) => {
            console.log("--", a1?.TSctRaeoMstAssessment?.asmSeq, a2?.TSctRaeoMstAssessment?.asmSeq
                , a1?.TSctRaeoMstAssessment?.asmSeq - a2?.TSctRaeoMstAssessment?.asmSeq);
            return a1?.TSctRaeoMstAssessment?.asmSeq - a2?.TSctRaeoMstAssessment?.asmSeq });
    });*/
    console.log("groupAssessArray", groupAssessArray);

    return groupAssessArray;
    // accumulator = [{header:{}, body:[{},{}]},{header:{}, body:[{},{}]}]
  };

  useEffect(() => {
    setGroupAssessArray(groupByAssess());
  }, [inputData]);

  useEffect(() => {
    validateForm();
  }, [groupAssessArray]);
  
  const handleChange = (idx) => {
    expandedList[idx] = !expandedList[idx];
    setExpandedList(...[expandedList]);
    setRefreshPage(refreshPage + 1);
  };

  const handleInputChangeCommon = (e, apasId) => {
    console.log("handleInputChangeCommon", e.target.name, e.target.value, apasId);
    //setInputData({ ...inputData, [e.target.name]: e.target.value });
    let assessArray = inputData.TSctRaeoAppAssessments || [];
    let idx = assessArray.findIndex(assess => apasId === assess.apasId);

    console.log("assessArray[idx] begin:", idx, assessArray[idx]);
    assessArray[idx][e.target.name] = e.target.value;
    console.log("assessArray[idx] end:", idx, assessArray[idx]);

    setRefreshPage(refreshPage + 1);
    //setInputData({...inputData});
    validateForm();
  }

  const validateForm = () => {
    const isValid = groupAssessArray.every((assGroup) =>
        assGroup.body.every((assess) => {
            if (assess.TSctRaeoMstAssessment.asmIsQuestion === 1) {
                return assess.apasResponse && assess.apasResponse.trim() !== "";
            } else {
                return true;
            }
        })
    );

    onRatingValidation(isValid);
    return isValid;
  };

  return (
    <React.Fragment>
      <C1HeaderTitle>Self Assessment</C1HeaderTitle>
      {groupAssessArray &&
        groupAssessArray.map((assGroup, idx) => (
          <Accordion
            expanded={expandedList[idx]}
            onChange={() => handleChange(idx)}
          >
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel1a-content"
              id={assGroup?.header?.TSctRaeoMstAssessment?.asmId}
              className={classes.heading}
            >
              <Typography>
                {assGroup?.header?.TSctRaeoMstAssessment?.asmId} &nbsp;
                {assGroup?.header?.TSctRaeoMstAssessment?.asmLabel}
              </Typography>
            </AccordionSummary>

            {assGroup.body.map((assess) => (
              <AccordionDetails>
                <Grid
                  container
                  alignItems="flex-start"
                  spacing={1}
                >
                  <Grid item lg={4} md={6} xs={12}>
                    <Typography>
                      {assess?.TSctRaeoMstAssessment?.asmId} &nbsp;{" "}
                      {assess.TSctRaeoMstAssessment.asmLabel}
                    </Typography>
                    </Grid>
                  <Grid item lg={3} md={6} xs={12}>
                    {assess?.TSctRaeoMstAssessment?.asmIsQuestion === 1 ? (
                      <C1InputField
                        label="Response"
                        name="apasResponse"
                        value={assess.apasResponse || ""}
                        multiline
                        rows={3}
                        disabled={true}
                        onChange={ (e) => handleInputChangeCommon(e, assess.apasId)}
                        inputProps={{ 'maxLength': 1024 }}
                      />
                    ) : null}
                  </Grid>
                  <Grid item lg={3} md={6} xs={12}>
                    {assess?.TSctRaeoMstAssessment?.asmIsQuestion === 1 ? (
                      <C1InputField
                        label="Observation"
                        name="apasObservation"
                        value={assess.apasObservation || ""}
                        multiline
                        rows={3}
                        required
                        disabled={isDisabled}
                        onChange={ (e) => handleInputChangeCommon(e, assess.apasId)}
                        inputProps={{ 'maxLength': 1024 }}
                      />
                    ) : null}
                  </Grid>
                  <Grid item lg={2} md={6} xs={12}>
                    {assess?.TSctRaeoMstAssessment?.asmIsQuestion === 1 ? (
                      <C1InputField
                        label="Risk Rating"
                        name="apasRating"
                        value={assess.apasRating || ""}
                        multiline
                        rows={3}
                        required
                        disabled={isDisabled}
                        onChange={ (e) => handleInputChangeCommon(e, assess.apasId)}
                        inputProps={{ 'maxLength': 1024 }}
                      />
                    ) : null}
                  </Grid>  
                  
                </Grid>
              </AccordionDetails>
            ))}
          </Accordion>
        ))}
      <Box>
        <C1InputField
            label="Assessment Summary"
            name="appAssessmentSummary"
            value={inputData?.appAssessmentSummary || ""}
            multiline
            rows={5}
            required
            disabled={isDisabled}
            onChange={ handleInputChangeDeepWrap}
            inputProps={{ 'maxLength': 1024 }}
          />
      </Box>
      <C1SelectField
            label="Assessment Recommendation"
            name="appAssessmentRecommend"
            required
            disabled={isDisabled}
            onChange={ handleInputChangeDeepWrap}
            value={inputData?.appAssessmentRecommend || ""}
            multiline
          >
            <MenuItem value="Recommended" key={1}>Recommended</MenuItem>
            <MenuItem value="RecommendedImprovement" key={2}>Recommended for Improvement Program</MenuItem>
            <MenuItem value="NotRecommended" key={3}>Not Recommended</MenuItem>
      </C1SelectField>

      <Box width={1}>&nbsp;</Box>

            <RaeoHistory auditList={auditList}>
            </RaeoHistory>

        </React.Fragment>
    );
};

export default RaeoAppAssessmentValidation;